module.exports = __webpack_public_path__ + "static/description-8cb2aa16181c3a11963aed1b11ce8162.webp";